import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    defaultTitle: {
        id: '_.draw_down.iwocaPay.order_summary.title',
        defaultMessage: 'Your payment plan'
    },
    subTitle: {
        id: '_.draw_down.iwocaPay.order_summary.sub_title',
        defaultMessage: '(Invoice amount: {amount})'
    },
    interestRateDisclaimer: {
        id: '_.draw_down.iwocaPay.order_summary.interestRateDisclaimer',
        defaultMessage: '*Your interest rate is {interestRate} per month.'
    }
});
